import { render, staticRenderFns } from "./3D.vue?vue&type=template&id=4c67c0c1&scoped=true"
import script from "./3D.vue?vue&type=script&lang=js"
export * from "./3D.vue?vue&type=script&lang=js"
import style0 from "./3D.vue?vue&type=style&index=0&id=4c67c0c1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c67c0c1",
  null
  
)

export default component.exports